// Modules
import { Link } from 'react-router';
import Mousetrap from 'mousetrap';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import pluralize from 'pluralize';

import { RoundLoader } from 'components/widgets/state-indicators/loader';
import { SecondaryButton } from 'components/widgets/buttons/buttons';
import { TextInput } from 'components/forms/form-elements';
import FlipMove from 'components/widgets/animation/flip-move';
import FormPopover from 'components/widgets/overlays/form';
import Person from 'services/data/person';
import SVG from 'components/widgets/icons/svg';
import Search from 'services/data/search';
import appHistory from 'app-history';

const nonSearchKeys = [
  'Meta',
  'Enter',
  'Shift',
  'Control',
  'Alt'
];

export default class SearchPopup extends React.Component {
  constructor() {
    super();
    this.state = { results: [] };
    this.close = this.close.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.search = _.debounce(this.search.bind(this), 200);
  }

  componentDidMount() {
    Mousetrap.bind('/', e => {
      this.popup.show();
      e.preventDefault();
    });
  }

  componentWillUnmount() {
    Mousetrap.unbind('/');
  }

  handleKeyUp(e) {
    if (!_.includes(nonSearchKeys, e.key)) return this.startSearch(e);

    if (e.key === 'Enter') {
      const { results } = this.state;
      const first = results[0];

      if (first) return appHistory.push(`/${pluralize(first.model)}/${first.id}/summary`);
    }
  }

  startSearch(e) {
    const q = e.target.value;

    if (!q) {
      this.setState({ searching: false, results: [] });
      return;
    }

    this.setState({ searching: true });
    this.search(q);
  }

  search(q) {
    // If we are already in the middle of searching cancel the promise
    if (this.searchPromise) this.searchPromise.cancel();

    this.searchPromise = Search.find({ q });

    this.searchPromise
      .then(results => {
        this.setState({ results, searching: false });
        this.searchPromise = null;
      });
  }

  close() {
    this.setState({ searching: false, results: [] });
    this.popup.hide();
  }

  render() {
    const { results, searching } = this.state;

    return (
      <FormPopover
        target={<SecondaryButton><SVG src="svg/search.svg" className="search" />Search</SecondaryButton>}
        className="search-wrapper"
        popoverClassName="search-popup"
        title="Portal Search"
        rootClose
        hideClose
        onHide={this.close}
        ref={(el) => { this.popup = el; }}
      >
        <TextInput autoFocus placeholder="type to search" onKeyUp={this.handleKeyUp} />
        { searching && <RoundLoader color="#34495e" className="page-loader" /> }
        { !searching &&
          <FlipMove typeName="ul" className="unstyled-list" enterAnimation="fade" leaveAnimation="fade">
            { _.map(results, item => {
              const { model, id } = item;

              return (
                <li key={`${model}-${id}`} className="search-result" onClick={this.close}>
                  { model === 'ticket' &&
                    <Link to={`/tickets/${id}/summary`} className={classNames('ticket-search-item', _.kebabCase(item.status))}>
                      <SVG src="svg/ticket.svg" className="ticket" />
                      <div>
                        <div>
                          {item.status !== 'Active' && <span className="emphasize">[{item.status}] </span>}
                          {item.description}
                        </div>
                        <div className="deemphasize">{item.company.name}</div>
                      </div>
                    </Link>
                  }

                  { model === 'company' &&
                    <Link to={`/companies/${id}/summary`} className="company-search-item">
                      <SVG src="svg/company.svg" className="company" />
                      <div>{item.name}</div>
                    </Link>
                  }

                  { model === 'person' &&
                    <Link to={`/people/${id}/summary`} className="person-search-item">
                      <SVG src="svg/person.svg" className="person" />
                      <div>
                        <div>{Person.fullName(item)}</div>
                        { item.company && item.company.id && <div className="deemphasize">{item.company.name}</div> }
                      </div>
                    </Link>
                  }
                </li>
              );
            }) }
          </FlipMove>
        }
      </FormPopover>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/search/popup.js